import { Component } from '@angular/core';
import { HostListener } from '@angular/core';
import { Renderer2 } from '@angular/core';
import { ElementRef } from '@angular/core';
import { title } from 'process';

@Component({
  selector: 'app-menu2',
  templateUrl: './menu2.component.html',
  styleUrls: ['./menu2.component.scss']
})
export class Menu2Component {
  isScrolled = false;
  logoSrc: string = 'assets/img/newlogo/ONESB-LOGO-GW.png'; // Default white logo
  private isHovered: boolean = false;
  isMobile = false;
  constructor(private renderer: Renderer2, private el: ElementRef) {}
  ngOnInit() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile.bind(this));
  }
  
  checkIfMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust breakpoint as needed
  }

/*   @HostListener('window:scroll', [])
  onWindowScroll() {
    const navbar = this.el.nativeElement.querySelector('.navbar');
    if (window.scrollY > 50) {
      this.renderer.addClass(navbar, 'solid-header');
    //  this.isScrolled =true;
    } else {
      this.renderer.removeClass(navbar, 'solid-header');
     // this.isScrolled =false;
    }
   
    const scrollPosition = window.scrollY;
    if (scrollPosition > 50) {
      this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-OG.png'; // Original logo on scroll
    //  this.isScrolled =true;
    } else {
      this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-GW.png'; // White logo at the top
     // this.isScrolled =false;
    }
    
  } */
 @HostListener('window:scroll', [])
onWindowScroll() {
  const navbar = this.el.nativeElement.querySelector('.navbar');
  if (navbar) {
    if (window.scrollY > 50) {
      this.renderer.addClass(navbar, 'solid-header');
    } else {
      this.renderer.removeClass(navbar, 'solid-header');
    }
  }

  const scrollPosition = window.scrollY;
  if (scrollPosition > 50) {
    this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-OG.png';
  } else {
    this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-GW.png';
  }
}


  menuOpen = false;

  menu = [
    {
      title: 'ABOUT US',
      expanded: false,
      children: [{ title: 'ABOUT US',link:'/about-us' }, { title: 'MENTORS',link:'/mentors' }, {title: 'COLLEGE COMMITTEE',link:'/college-commitee'}, {title: 'VISSION MISSION',link:'/vision-mission'} , {title: 'CORPORATES',link:'/corporates'}]
    },
    {
      title: 'PROGRAMS',
      expanded: false,
      children: [{ title: 'UNDER GRADUATE',link:'/program' }, { title: 'GRADUATE',link:'/program' }, { title: 'MASTER\'S DUAL DEGREE',link:'/program'}, { title: 'BACHELOR\'S DUALL DEGREE',link:'/program' }, { title: 'CERTIFICATION' ,link:'/program'}, { title: 'ONESB SUMMER PROGRAM' ,link:'/program'}]
    },
    {
      title: 'ADMISSIONS & FINANCIAL AID',
      expanded: false,
      children: [{ title: 'ADMISSIONS',link:'/admission-financial' }, { title: 'FINANCIAL AID',link:'/admission-financial' }, {title: 'STUDENT SERVICES' ,link:'/admission-financial'}]
    },
    {
      title: 'ONESB UNIVERSITY EXPERIENCE',
      expanded: false,
      children: [{ title: 'Campus Life' ,link:'/campus-life'}, { title: 'TALENT & CAREERS',link:'/admission-financial' }, {title: 'ALUMNI DEPARMENT' ,link:'/students-alumni'}, {title:'STUDENTS & ALUMNI STORIES',link:'/admission-financial'}, {title: 'CHAT WITH OUR STUDENTS AND STAFF',link:'/chat-students-staff' }]
    },
    {
      title: 'FACULTY & RESEARCH',
      expanded: false,
      children: [{ title: 'Professors' ,link:''}, { title: 'Research Areas'  ,link:''}]
    },
    {
      title: 'INITIATIVES & CENTERS',
      expanded: false,
      children: [{title: 'EXPONENTIAL SCIENCE LAB' ,link:''},{title: 'MENTORSHIP PROGRAM' ,link:''},{title: 'TECH VENTURE BOOTCAMP' ,link:''},{title: 'ONESB SUSTAINABILITY DATATHON'},{title: 'RAISE EUROPE ALLIANCE'},{title: 'BERKELEY IMMERSION WEEK'},{title: 'METAVERSE CATALYST CONFERENCE'},{title: 'MANAGEMENT XPONENTIAL TECHONOLOGY (MXT)'}] 
    }
  ];
  

toggleMenu() {
  this.menuOpen = !this.menuOpen;
}

toggleSection(section: any) {
  section.expanded = !section.expanded;
}
  
  mobileMenuOpen = false;
  activeMenu: any = null;

  MENUITEMS = [
    {
      title: "Home",
      path: "/",
      type: "link",
      active: false,
    },
    {
      title: "About us",
      type: "sub",
      active: false,
      children: [
        { path: "/about-us", title: "About us", type: "link" },
        { path: "/vision-mission", title: "Vision Mission", type: "link" },
        {
          title: "Committee",
          type: "sub",
          children: [
            {
              title: "College Committee",
              type: "link",
              path: "/college-committee",
            },
          ],
        },
        { path: "/mentors", title: "Mentors", type: "link" },
        { path: "/corporates", title: "Corporates", type: "link" },
      ],
    },
    {
      title: "Programme",
      type: "sub",
      active: false,
      children: [
        {
          title: "UG Programme",
          type: "sub",
          children: [
            { path: "/course/BBA", title: "BBA", type: "link" },
            { path: "/course/BBA-Aviation", title: "BBA Aviation", type: "link" },
          ],
        },
        {
          title: "PG Programme",
          type: "sub",
          children: [

            {path: "/course/mba-prime", title: "MBA Prime", type: "link"},
            {path: "/course/mba-catalyst", title:"MBA Catalyst", type: "link"},
            {path: "/course/mba-pinnacle", title: "MBA Pinnacle + PCIP", type: "link"}
            /* { path: "/course/MBA-international", title: "MBA international", type: "link" },
            { path: "/course/MBA-Global", title: "MBA Global", type: "link" },
            { path: "/course/MBA-Advance", title: "MBA Advance", type: "link" }, */
          ],
        },
        {
          title: "Doctorate",
          path: "/doctorate",
          type:"link",
          active: false,
        
        },
        {
          title: "Certification Programme",
          path:"/certification-programme"
          
          /*type: "sub", 
            children: [
            { path: "/course/CBAP", title: "CBAP", type: "link" },
            { path: "/course/CFM", title: "CFM", type: "link" },
            { path: "/course/CHRAP", title: "CHRAP", type: "link" },
            { path: "/course/CAT", title: "CAT", type: "link" },
            { path: "/course/CMAP", title: "CMAP", type: "link" },
            { path: "/course/CLM", title: "CLM", type: "link" },
            { path: "/course/CAI", title: "CAI", type: "link" },
            { path: "/course/CDM", title: "CDM", type: "link" },
            { path: "/course/CBA", title: "CBA", type: "link" },
            { path: "/course/CMIS", title: "CMIS", type: "link" },
          ], */
        },
      ],
    },
    {
      title: "Admission",
      path: "/admission",
      type: "link",
      active: false,
    },
    {
      title: "Life @ONESB",
      path: "/student-life",
      type: "sub",
      active: false,
      children: [
        { path: "/student-life", title: "Student life", type: "link" },
      ],
    },
    {
      title: "Gallery",
      type: "sub",
      active: false,
      children: [
        { path: "/onam", title: "Onam", type: "link" },
        { path: "/sports", title: "Sports", type: "link" },
        { path: "/library", title: "Library", type: "link" },
        { path: "/annual", title: "Annual Day", type: "link" },
        { path: "/kannadostva", title: "Kannadostva", type: "link" },
      ],
    },
    {
      title: "Finishing School",
      path: "/finishing-school",
      type: "link",
      active: false,
    },
    {
      title: "Center Of Excellence",
      path: "/center-of-excellence",
      type: "link",
      active: false,
    },
    {
      title: "Placements",
      type: "sub",
      active: false,
       path: "/placement-overview",
    },
  ];
  

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  setActiveMenu(menuItem: any) {
    this.activeMenu = menuItem;
  }

  clearActiveMenu(menuItem: any) {
    if (this.activeMenu === menuItem) {
      this.activeMenu = null;
    }
  }
  activeDropdown: any = null;

  openDropdown(dropdown: any) {
    // Close the previously active dropdown (if any)
    if (this.activeDropdown && this.activeDropdown !== dropdown) {
      this.activeDropdown.close();
    }
    
    // Open the new dropdown
    dropdown.open();
    this.activeDropdown = dropdown;
  }
  closeDropdown() {
    // Close any open mega menu
    if (this.activeDropdown) {
      this.activeDropdown.close();
      this.activeDropdown = null;
    }
  }
   onMouseEnterHeader() {
    if (!this.isScrolled) {
        console.log(this.isScrolled)
      this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-OG.png'; // Change logo on hover
    }
   
  }

  onMouseLeaveHeader() {
    if (!this.isScrolled) {
      console.log(this.isScrolled)
      this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-GW.png'; // Restore white logo when not hovered
    }
   
  } 
  
/*     onMouseEnterHeader() {
      console.log("Mouse Enter:", this.isScrolled);
      
      if (this.isScrolled) {
        // When scrolled, change logo to white on hover
        this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-GW.png';
      } else {
        // When at the top, change logo to original on hover
        this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-OG.png';
      }
    }
    
    onMouseLeaveHeader() {
      console.log("Mouse Leave:", this.isScrolled);
      
      if (this.isScrolled) {
        // When scrolled, revert to the original logo after hover
        this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-OG.png';
      } else {
        // When at the top, revert to the white logo after hover
        this.logoSrc = 'assets/img/newlogo/ONESB-LOGO-GW.png';
      }
    } */
    
}
